import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "@/contexts/AuthContext";

/**
 * Custom hook for accessing auth state with optional redirect
 * Uses centralized AuthContext - no duplicate subscriptions
 */
export const useAuth = (requireAuth = true) => {
  const navigate = useNavigate();
  const { user, session, loading, isInitialized, isAuthenticated, signOut } = useAuthContext();

  // Redirect logic - only after initialization
  useEffect(() => {
    if (!isInitialized) return;
    
    const currentPath = window.location.pathname;
    if (currentPath === '/') return;
    
    if (requireAuth && !user) {
      navigate(`/?auth=true&next=${encodeURIComponent(currentPath)}`);
    }
  }, [isInitialized, requireAuth, user, navigate]);

  return {
    user,
    session,
    loading,
    isInitialized,
    signOut,
    isAuthenticated,
  };
};
